import { FormattedMessage, useIntl } from 'react-intl';
import { Link } from 'react-router-dom';

import { ExternalLinkIcon } from '@/components/icons/external-link';
import { Banner } from '@/components/ui/banner';
import { Button } from '@/components/ui/button';
import { useOpeningContext } from '@/contexts/opening-context';

/**
 * Banner shown when the current opening is inactive or/and sourcing is disabled.
 * with a link to edit opening page
 * If the opening is inactive or sourcing is disabled, the respective banner is shown
 * If the opening is both inactive and sourcing is disabled, inactive banner would be shown
 */
export function PostingUnavailableBanner() {
  const intl = useIntl();
  const { isOpeningActive, isSourcingEnabled, openingUrl } =
    useOpeningContext();

  if (isOpeningActive && isSourcingEnabled) {
    return null;
  }

  return (
    <Banner
      color="rose"
      title={
        !isOpeningActive
          ? intl.formatMessage({
              defaultMessage: 'Opening Inactive — Job Posting Disabled',
            })
          : intl.formatMessage({ defaultMessage: 'Sourcing Disabled' })
      }
      description={
        !isOpeningActive
          ? intl.formatMessage({
              defaultMessage:
                'This opening is inactive. Posting to job boards and sourcing campaigns are paused. Activate the opening to resume hiring.',
            })
          : intl.formatMessage({
              defaultMessage:
                'Sourcing is turned off for this opening. Job posting and campaigns are paused until sourcing is enabled.',
            })
      }
      button={
        openingUrl && (
          <Button variant="secondary" asChild>
            <Link to={openingUrl} target="_blank">
              <ExternalLinkIcon className="text-fx-neutral-900" />
              {!isOpeningActive ? (
                <FormattedMessage defaultMessage="Activate opening" />
              ) : (
                <FormattedMessage defaultMessage="Enable Sourcing" />
              )}
            </Link>
          </Button>
        )
      }
    />
  );
}
